import React, {useState, useEffect} from 'react';
import { Typography } from '@mui/material';
import { getGroups } from '../../services/group-services';
import GroupListItem from './group-list-item';
import {useAuth} from "../../hooks/useAuth";
import {useNavigate} from "react-router-dom";


function GroupList() {

  const { authData } = useAuth();
  const [ groups, setGroups] = useState(null);
  const [ loading, setLoading] = useState(false);
  const [ error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(()=>{
    const getData = async () => {
      await getGroups(authData.token)
          .then( data => {
            setGroups(data);
            setLoading(false);
          }).catch( e => {
            setError(true);
            setLoading(false);
          })
    }
    if (authData){
      setLoading(true);
      getData();
    } else {
      navigate("/login");
    }
  }, [authData, navigate])

  if (error) return <Typography variant="h1" sx={{ textAlign: 'center', mt: 4 }}>Error</Typography>
  if (loading) return <Typography variant="h2" sx={{ textAlign: 'center', mt: 4 }}>Loading…</Typography>

  return (
    <div>
        { groups && groups.map(group => {
          return <GroupListItem key={group.id} group={group} />
        })}
    </div>
  );
}

export default GroupList;
